var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.904 21.24l-10.661-18.631c-0.21-0.457-0.651-0.775-1.168-0.807l-0.004-0c-0.689 0-1.112 0.858-1.112 0.858l-10.86 18.575c-0.305 0.515 0.133 1.124 0.808 1.124h22.187c0.672-0.001 1.11-0.605 0.811-1.118zM11.996 19.907c-0.497 0-0.9-0.403-0.9-0.9s0.403-0.9 0.9-0.9c0.497 0 0.9 0.403 0.9 0.9v0c-0.001 0.497-0.403 0.899-0.9 0.899 0 0 0 0 0 0v0zM12.904 15.553c0 0.497-0.403 0.9-0.9 0.9s-0.9-0.403-0.9-0.9v0-6.211c0-0.497 0.403-0.9 0.9-0.9s0.9 0.403 0.9 0.9v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.487b0287.svg";
export { ForwardRef as ReactComponent };